import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      {/* Navigation */}
      <nav className="terms-nav">
        <div className="nav-content">
          <Link to="/" className="nav-logo">
            <img src="/logo.png" alt="TasteCircle" className="logo-icon" />
            <span className="brand-name">TasteCircle</span>
          </Link>
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </nav>

      {/* Terms Content */}
      <div className="terms-container">
        <div className="terms-header">
          <h1 className="terms-title">Terms of Service</h1>
          <p className="terms-date">Last Updated: January 1, 2025</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using TasteCircle ("the Service"), you agree to be bound by these Terms of Service ("Terms"). 
              If you do not agree to these Terms, you may not access or use the Service. These Terms apply to all visitors, 
              users, and others who access or use the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              TasteCircle is a private photo-sharing application that allows users to share daily food photos with selected 
              groups of friends ("Circles"). The Service includes the TasteCircle mobile application, website, and any related 
              services provided by TasteCircle.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. User Accounts</h2>
            <h3>3.1 Account Creation</h3>
            <p>
              To use certain features of the Service, you must create an account. You must be at least 13 years old to create 
              an account. You agree to provide accurate, current, and complete information during the registration process 
              and to update such information to keep it accurate, current, and complete.
            </p>
            <h3>3.2 Account Security</h3>
            <p>
              You are responsible for safeguarding the password and for all activities that occur under your account. 
              You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
            </p>
            <h3>3.3 Account Termination</h3>
            <p>
              We reserve the right to suspend or terminate your account if you violate these Terms or engage in any 
              activity that we determine is inappropriate or unlawful.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. User Content</h2>
            <h3>4.1 Your Content</h3>
            <p>
              You retain all rights to the content you post on TasteCircle ("User Content"). By posting User Content, 
              you grant us a non-exclusive, worldwide, royalty-free, sublicensable, and transferable license to use, 
              reproduce, distribute, prepare derivative works of, display, and perform the User Content solely in 
              connection with the Service.
            </p>
            <h3>4.2 Content Guidelines</h3>
            <p>You agree not to post User Content that:</p>
            <ul>
              <li>Violates any law or regulation</li>
              <li>Is defamatory, obscene, pornographic, or offensive</li>
              <li>Infringes any third party's intellectual property rights</li>
              <li>Contains viruses or malicious code</li>
              <li>Is spam or commercial solicitation</li>
              <li>Impersonates another person or entity</li>
              <li>Contains private information of others without consent</li>
              <li>Promotes harmful or dangerous activities</li>
            </ul>
            <h3>4.3 Content Moderation</h3>
            <p>
              We reserve the right to remove any User Content that violates these Terms or that we find objectionable. 
              However, we are not obligated to monitor or review User Content.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Privacy and Data Protection</h2>
            <h3>5.1 Privacy Policy</h3>
            <p>
              Your use of the Service is subject to our Privacy Policy, which describes how we collect, use, and 
              share your information. By using the Service, you consent to our collection and use of your information 
              as described in the Privacy Policy.
            </p>
            <h3>5.2 Data Security</h3>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data. However, 
              no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee 
              absolute security.
            </p>
            <h3>5.3 GDPR Compliance</h3>
            <p>
              For users in the European Economic Area, we comply with the General Data Protection Regulation (GDPR). 
              You have the right to access, rectify, erase, restrict processing, data portability, and object to 
              processing of your personal data.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Intellectual Property Rights</h2>
            <h3>6.1 Our Rights</h3>
            <p>
              The Service and its original content (excluding User Content), features, and functionality are owned 
              by TasteCircle and are protected by international copyright, trademark, patent, trade secret, and 
              other intellectual property laws.
            </p>
            <h3>6.2 Feedback</h3>
            <p>
              Any feedback, suggestions, or ideas you provide about the Service may be used by us without any 
              obligation to compensate you.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Prohibited Uses</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the Service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any portion of the Service</li>
              <li>Use any robot, spider, or other automatic device to access the Service</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Reverse engineer or attempt to extract the source code of the Service</li>
              <li>Sell, rent, or sublicense any part of the Service</li>
              <li>Use the Service to send unsolicited communications</li>
              <li>Create multiple accounts for abusive purposes</li>
              <li>Collect or harvest user information without consent</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Third-Party Services</h2>
            <p>
              The Service may contain links to third-party websites or services that are not owned or controlled by us. 
              We have no control over and assume no responsibility for the content, privacy policies, or practices of 
              any third-party websites or services.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Disclaimers</h2>
            <h3>9.1 Service Availability</h3>
            <p>
              The Service is provided "as is" and "as available" without any warranties of any kind, either express 
              or implied. We do not guarantee that the Service will be uninterrupted, secure, or error-free.
            </p>
            <h3>9.2 Content Accuracy</h3>
            <p>
              We do not endorse, guarantee, or assume responsibility for the accuracy, reliability, or completeness 
              of any User Content.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, TasteCircle shall not be liable for any indirect, incidental, 
              special, consequential, or punitive damages, including but not limited to loss of profits, data, use, 
              goodwill, or other intangible losses resulting from your use of the Service.
            </p>
            <p>
              In no event shall our total liability to you for all damages exceed the amount you have paid us in the 
              twelve (12) months prior to the event giving rise to the liability, or one hundred dollars ($100) if 
              you have not made any payments.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless TasteCircle and its officers, directors, employees, 
              and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, 
              or fees arising out of or relating to your violation of these Terms or your use of the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Dispute Resolution</h2>
            <h3>12.1 Arbitration</h3>
            <p>
              Any dispute arising out of or relating to these Terms or the Service shall be resolved through binding 
              arbitration in accordance with the rules of the American Arbitration Association. The arbitration shall 
              be conducted in English and the arbitrator's decision shall be final and binding.
            </p>
            <h3>12.2 Class Action Waiver</h3>
            <p>
              You agree that any arbitration or legal proceedings shall be conducted only on an individual basis and 
              not as a class action or representative action.
            </p>
          </section>

          <section className="terms-section">
            <h2>13. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of California, 
              United States, without regard to its conflict of law provisions. Any legal action or proceeding shall 
              be brought exclusively in the courts located in San Francisco County, California.
            </p>
          </section>

          <section className="terms-section">
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. If we make material changes, we will notify 
              you by email or through the Service at least 30 days before the changes take effect. Your continued 
              use of the Service after the changes become effective constitutes your acceptance of the revised Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>15. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice 
              or liability, for any reason, including if you breach these Terms. Upon termination, your right to 
              use the Service will immediately cease.
            </p>
          </section>

          <section className="terms-section">
            <h2>16. Children's Privacy</h2>
            <p>
              The Service is not intended for children under 13 years of age. We do not knowingly collect personal 
              information from children under 13. If we discover that a child under 13 has provided us with personal 
              information, we will delete such information immediately.
            </p>
          </section>

          <section className="terms-section">
            <h2>17. DMCA Copyright Policy</h2>
            <p>
              We respect the intellectual property rights of others. If you believe that any content on the Service 
              infringes your copyright, please send a notice to our designated copyright agent with the following 
              information:
            </p>
            <ul>
              <li>A description of the copyrighted work</li>
              <li>The location of the infringing material</li>
              <li>Your contact information</li>
              <li>A statement of good faith belief</li>
              <li>A statement of accuracy under penalty of perjury</li>
              <li>Your physical or electronic signature</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>18. Severability</h2>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall 
              continue in full force and effect.
            </p>
          </section>

          <section className="terms-section">
            <h2>19. Entire Agreement</h2>
            <p>
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and TasteCircle 
              regarding the use of the Service and supersede any prior agreements.
            </p>
          </section>

          <section className="terms-section">
            <h2>20. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="contact-info">
              TasteCircle, Inc.<br />
              Email: legal@tastecircle.app<br />
            </p>
          </section>

          <section className="terms-section acknowledgment">
            <h2>Acknowledgment</h2>
            <p>
              By using the Service, you acknowledge that you have read, understood, and agree to be bound by these 
              Terms of Service and our Privacy Policy.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
